// extracted by mini-css-extract-plugin
export default {"userAvatar":"NotificationDropdown_userAvatar__7AA7v","hasImage":"NotificationDropdown_hasImage__4Tr4J"};